// @givmo/app-charity — donor-analytics route constants (CPB-WEB6).
//
// Same route-constant convention as `features/grants/grants-routes.ts`. Analytics is a single screen
// of the DONATIONS module (the CRM-1 split: Donations-module content), so it lives under the
// module's address beside Payments — the sidebar reads every page under `/donations` as inside the
// module, and the page wears the Donations frame whether it is followed from its row or loaded
// directly. `/analytics`, its address before, is a replace-redirect registered with it (a dark
// build answers not-found at both). It is independently revealed by
// `VITE_CHARITY_DONOR_ANALYTICS_ENABLED`; the backend's `CHARITY_DONOR_ANALYTICS_ENABLED` is its sole
// runtime gate.

export const ANALYTICS_ROUTES = {
  dashboard: '/donations/analytics',
  /** RETIRED — the page's address before it joined the Donations family; a replace-redirect. */
  retired: '/analytics',
} as const;
